import React from 'react';
import PropTypes from 'prop-types';

import errorIcon from './i_error.png';
import infoIcon from './i_info.png';
import {extractGroupErrors} from 'validation'

export class TabPanel extends React.Component {
    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}

TabPanel.propTypes = {

    /**
     * The panel header.
     */
    header: PropTypes.string.isRequired,

    /**
     * Array of the errors that are occurred in the current tab.
     */
    errorMessage: PropTypes.array
};

export class TabView extends React.Component {

    state = {
        activeIndex: 0
    };

    tabRefs = new Set();

    onTabClick(e, i) {
        const newEvent = {originalEvent: e, index: i};
        if (this.props.onTabClick) {
            this.props.onTabClick(newEvent);
        }
        if (!newEvent.preventTabChange) {
            this.setState({activeIndex: i});
        }

        this.props.hideInfoIcon();

        e.preventDefault();
    }

    retrieveErrorMsg = (errorMessages, groups) => {
        const tabMessages = extractGroupErrors(errorMessages, groups);
        if (tabMessages.length > 0) {
            return tabMessages.join('\n');
        } else {
            return null;
        }
    };

    onArrowKeyPress(e, index) {
        const refs = [...this.tabRefs];
        let nextIndex;
        if(e.key === "ArrowLeft" && index > 0) {
            nextIndex = index - 1;
        }
        else if(e.key === "ArrowRight" && index < refs.length - 1) {
            nextIndex = index + 1;
        }

        if(nextIndex !== undefined) {
            refs[nextIndex].focus();
            this.onTabClick(e, nextIndex);
        }
    };

    render() {
        return (
            <div className={this.props.className}>
                <ul role="tablist">
                    {React.Children.map(this.props.children, (tab, i) => {
                        const selected = this.state.activeIndex === i;
                        const errorMsg = this.retrieveErrorMsg(this.props.errorMessages, tab.props.groups);
                        const newDataUploaded = tab.props.newDataUploaded && selected;
                        return (
                            <li className={selected ? "active" : undefined}>
                                <a href="#" onClick={(e) => this.onTabClick(e, i)} tabIndex={selected ? 0 : -1} role="tab"
                                    aria-selected={selected} onKeyDown={(e) => this.onArrowKeyPress(e, i)}
                                    ref={(tabLink) => tabLink ? this.tabRefs.add(tabLink) : undefined}
                                    title={errorMsg}>
                                    <span>{tab.props.header}</span>
                                    {errorMsg ? <img src={errorIcon} alt=" "/> : ""}
                                    {newDataUploaded ? <img src={infoIcon} alt=" " title={this.props.infoMessage}/> : ""}
                                </a>
                            </li>
                        );
                    })
                    }
                </ul>
                <div>
                    {React.Children.map(this.props.children, (tab, i) => {
                        const selected = this.state.activeIndex === i;
                        return (
                            <div role="tabpanel" aria-hidden={!selected} style={selected ? {display: 'block'} : {display: 'none'}}>
                                {tab}
                            </div>
                        );
                    })
                    }
                </div>
            </div>
        );
    }
}

TabView.propTypes = {
    /**
     * Javascript code that has to be executed on tab click.
     */
    onTabClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/common/TabView/index.js